/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../unleash";

export const FlagsNetwork = {
  list_csv_enable: new FcsFlag.Flag(false),
  list_csv_detail: new FcsFlag.Flag(false),
  list_ursa_code_enable: new FcsFlag.Flag(false),
  list_ursa_code_detail: new FcsFlag.Flag(false)
};

export const initFlagsNetwork = () => {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureNetwork", FlagsNetwork);
};
